import React, { useState } from 'react';
import { Button, message,} from 'antd';
import { DownloadOutlined} from '@ant-design/icons';
import { GenericExportCSVProps, BaseTableData } from '../../types/TableTypes';

const GenericExportCSV = <T extends BaseTableData>({
  allData,
  exportColumns,
  filename = "データ",
  loading = false,
  fetchAllData,
}: GenericExportCSVProps<T>) => {
  const [exporting, setExporting] = useState(false);
  const convertToCSV = (data: T[]): string => {
    const headers = exportColumns.map((col) => col.title);

    const rows = data.map((item) =>
      exportColumns.map((col) => {
        const value = item[col.dataIndex];

        if (col.exportFormatter) {
          return col.exportFormatter(value);
        }

        if (Array.isArray(value)) {
          return `"${value.join(", ")}"`;
        }

        if (typeof value === "object" && value !== null) {
          return `"${JSON.stringify(value)}"`;
        }

        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
        ) {
          return `"${value.replace(/"/g, '""')}"`;
        }

        if (value === null || value === undefined) {
          return "";
        }

        return value;
      })
    );

    const csvContent = [headers, ...rows]
      .map((row) => row.join(","))
      .join("\n");

    return csvContent;
  };

  const downloadCSV = (csvContent: string, filename: string) => {
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.csv`);
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const handleExportAll = async () => {
    setExporting(true);

    try {
      let dataToExport: T[];

      if (fetchAllData) {
        dataToExport = await fetchAllData();
      } else {
        dataToExport = allData || [];
      }

      if (dataToExport.length === 0) {
        message.warning("エクスポートするデータがありません");
        return;
      }

      const csvContent = convertToCSV(dataToExport);
      const currentDate = new Date().toISOString().split("T")[0];
      const exportFilename = `${filename}-${currentDate}`;

      downloadCSV(csvContent, exportFilename);
      message.success(`${dataToExport.length}件をエクスポートしました`);
    } catch (error) {
      message.error(
        error instanceof Error ? error.message : "エクスポート中にエラーが発生しました"
      );
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      type='primary'
      icon={<DownloadOutlined />}
      loading={exporting || loading}
      className='export-csv-button'
      onClick={handleExportAll}
    >
      CSVエクスポート
    </Button>
  );
};

export default GenericExportCSV;